import React, { FC } from 'react'

import { BookingCheckInIssue } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'
import { checkInInstructionsIssuesFilterOptions } from '@new/__global/constants/filter'

interface CheckInInstructionsIssuesFilterProps extends FiltersSharedProps {
  initialValue?: BookingCheckInIssue[]
  onChange: (value?: BookingCheckInIssue[]) => void
  title: string
}

export const CheckInInstructionsIssuesFilter: FC<CheckInInstructionsIssuesFilterProps> = props => (
  <CheckboxBasedFilter options={checkInInstructionsIssuesFilterOptions} {...props} />
)
